<template>
    <v-overflow-btn
        v-model="selectedIdx"
        @change="selectPeriod"
        :items="periods"
        label="Tryout"
    >
    </v-overflow-btn>
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
    computed: {
        selectedIdx: sync('enrollment/selectedIdx'),

        periods() {
            const periods = this.$store.get('enrollment/enrollments').map((enrollment, idx) => {
                return {
                    value: idx,
                    text: enrollment.title + (enrollment.is_trial ? ' (Trial)' : ''),
                }
            })

            periods.push({
                value: 'enroll',
                text: 'Daftar Baru',
            })

            return periods
        }
    },

    methods: {
        selectPeriod() {
            if (this.selectedIdx === 'enroll') {
                this.$router.push({ name: 'enrollment' })
            } else if (! this.$store.get('enrollment/selected@is_active')) {
                localStorage.setItem('lastSelectedPeriodId', this.$store.get('enrollment/selected@id'))
                this.$router.push({ name: 'payment' })
            } else {
                localStorage.setItem('lastSelectedPeriodId', this.$store.get('enrollment/selected@id'))
                if (this.$route.name === 'dashboard') {
                    this.$router.go()
                }

                this.$router.push({ name: 'dashboard' })
            }
        }
    }
}
</script>
